var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"09b30b0d5ed13952313aa35833851c1776399796"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["denham-site@ask-phill"]={id:"09b30b0d5ed13952313aa35833851c1776399796"};
      